import { useField } from "react-final-form";
import Help from "../../components/help";
import { isDefined, isFunction } from "../../utils/type-util";
import { jsx as _jsx } from "react/jsx-runtime";
function FieldError(_ref) {
  let {
    name,
    showError,
    ...rest
  } = _ref;
  const {
    meta
  } = useField(name);
  const errorVisible = getErrorVisible(showError, meta);
  const error = errorVisible ? meta.error : "";
  return /*#__PURE__*/_jsx(Help, {
    status: "error",
    ...rest,
    children: error
  });
}
function getErrorVisible(showError, meta) {
  if (isFunction(showError)) {
    return !!showError(meta);
  }
  if (isDefined(showError)) {
    return !!showError;
  }
  return meta.touched;
}
export default FieldError;